import { useCallback, useState } from "react";
import { useApi } from "../apiCall/useApi";
import Joi from "joi";
import { Urls } from "../../../utils/constant";
import { size } from "lodash";
import { useSnackbar } from "notistack";

import {
  hidePageLoader,
  showPageLoader,
} from "../../reducers/Common/PageLoader/PageLoader.reducer";
import { useDispatch, useSelector } from "react-redux";

import Api from "../../../utils/api.utils";
import useFullPageLoader from "../Common/PageLoader/useFullPageLoader";
import { getDoctorList } from "../../selectors/Faq/Faq.selector";
import { setFaqData } from "../../reducers/Faq/FaqForm.reducer";

export const faqEntrySchema = Joi.object({
  name: Joi.string().required().messages({
    "string.empty": "Please Select a Doctor Name ",
  }),

  question: Joi.string().required().messages({
    "string.empty": "Question is required.",
  }),
  answer: Joi.string().required().messages({
    "string.empty": "Answer is required",
  }),
});

export function useFaqForm({ existingStatus, existingDoctorName }) {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { apiPost } = useApi();
  const [loading, setLoading] = useState(false);

  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [status, setStatus] = useState(existingStatus === 2 ? 0 : 1);
  const [Id, setId] = useState("");
  const [Answer, setAnswer] = useState("");
  const [Question, setQuestion] = useState("");
  const doctorList = useSelector(getDoctorList);
  const [DoctorId, setDoctorId] = useState(
    size(existingDoctorName) > 0 ? existingDoctorName : null
  );

  const handleDeleteId = useCallback(
    (row) => {
      setId(row.id);
      setQuestion(row.question);
      setDoctorId(row.doctor_id);
      setAnswer(row.answer);
    },
    [Id, Question, Answer, DoctorId]
  );

  const faqEntry = useCallback(

    async ({ question, answer }) => {
      const status_Val = status === false ? 2 : status === 0 ? 2 : 1;
      if (loading) return;
      setLoading(true);
      
      try {
        dispatch(showPageLoader());
        const { data } = await apiPost({
          url: Urls.faqAdd(),  
          data: {
            doctor_id: DoctorId,
            question: question,
            answer: answer,
            status: status_Val,
            insert_by: null,
          },
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });

        if (size(data.id) === 36) {
          enqueueSnackbar("FAQ Data Added Successfully.", {
            variant: "success",
          });
         
          return true;
         
        }

        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
        return false;
      }
    },
    [status, loading, DoctorId]
  );

  const faqUpdate = useCallback(
    async ({ id, question, answer }) => {
      if (loading) return;
      setLoading(true);
      const status_Val = status === false ? 2 : status === 0 ? 2 : 1;
      //   const formattedReportDate = format(ReportDate, 'yyyy-MM-dd');
      try {
        dispatch(showPageLoader());
        const { data } = await apiPost({
          url: Urls.faqUpdate(),
          data: {
            id: id,
            doctor_id: DoctorId,
            question: question,
            answer: answer,
            status: status_Val,
            update_by: "",
          },
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        if (size(data?.id) === 36) {
          enqueueSnackbar("FAQ Data Updated Successfully.", {
            variant: "success",
          });
          return true;
        }

        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
        return false;
      }
    },
    [status, loading, DoctorId]
  );

  const faqDelete = useCallback(async () => {
    //   const formattedReportDate = format(ReportDate, 'yyyy-MM-dd');
    try {
      dispatch(showPageLoader());
      const { data } = await apiPost({
        url: Urls.faqUpdate(),
        data: {
          id: Id,
          doctor_id: DoctorId,
          question: Question,
          answer: Answer,
          status: 2,
          update_by: "",
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (size(data.id) === 36) {
        enqueueSnackbar("FAQ Data Deleted Successfully.", {
          variant: "success",
        });
        return true;
      }

      setLoading(false);
      dispatch(hidePageLoader());
    } catch (err) {
      dispatch(hidePageLoader());
      console.log(err);
      setLoading(false);
      return false;
    }
  }, [status, Id, Question, Answer, DoctorId]);

  const findDoctorFromLabel = useCallback((value) => {
    const selectedDoctorId = value
      ? doctorList.find((item) => item.label === value)?.id
      : null;
    setDoctorId(selectedDoctorId);
    return selectedDoctorId;
  }, []);

  const getFaqById = useCallback(
    async (id) => {
      if (loading) return;
      setLoading(true);
      try {
        dispatch(showPageLoader());

        const { data } = await apiPost({
          url: Urls.getFaqById(),
          data: {
            id: id,
          },
        });

        dispatch(setFaqData(data));
        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
        return false;
      }
    },
    [loading]
  );

  const handleStatusComboChange = useCallback((event) => {
    if (event.target.checked === 1) {
      setStatus(event.target.checked);
    } else {
      setStatus(event.target.checked);
    }
  }, []);

  return {
    loader,
    loading,
    status,
    faqEntrySchema,
    handleStatusComboChange,
    faqEntry,
    findDoctorFromLabel,
    DoctorId,
    faqUpdate,
    getFaqById,
    handleDeleteId,
    faqDelete,
  };
}
